import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getExpenseCategories,
  getExpenseCategoryById,
  createExpenseCategory,
  updateExpenseCategory,
  deleteExpenseCategory,
} from "../../api/admin/tournamentExpenseCategories.api";

/* ============================================================
   RESPONSE NORMALIZER
============================================================ */

const normalizeResponse = (res) => {
  let data = [];

  if (Array.isArray(res?.data)) {
    data = res.data;
  } else if (Array.isArray(res?.data?.data)) {
    data = res.data.data;
  }

  return {
    data,
    meta: {
      total: res?.count || data.length,
      total_pages: 1,
      page: 1,
      limit: data.length,
    },
  };
};

/* ============================================================
   FETCH ALL
============================================================ */

export const fetchExpenseCategories = createAsyncThunk(
  "admin/tournamentExpenseCategories/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getExpenseCategories();

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return normalizeResponse(res);

    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to fetch expense categories"
      );
    }
  }
);

/* ============================================================
   FETCH BY ID
============================================================ */

export const fetchExpenseCategoryById = createAsyncThunk(
  "admin/tournamentExpenseCategories/fetchById",
  async (id, { rejectWithValue }) => {
    try {
      const res = await getExpenseCategoryById(id);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res.data;

    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to fetch expense category"
      );
    }
  }
);

/* ============================================================
   CREATE
============================================================ */

export const addExpenseCategory = createAsyncThunk(
  "admin/tournamentExpenseCategories/add",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await createExpenseCategory(payload);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;

    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to create expense category"
      );
    }
  }
);

/* ============================================================
   UPDATE
============================================================ */

export const updateExpenseCategoryThunk = createAsyncThunk(
  "admin/tournamentExpenseCategories/update",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const res = await updateExpenseCategory(id, payload);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return {
        id,
        data: payload,
      };

    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to update expense category"
      );
    }
  }
);

/* ============================================================
   DELETE
============================================================ */

export const deleteExpenseCategoryThunk = createAsyncThunk(
  "admin/tournamentExpenseCategories/delete",
  async (id, { rejectWithValue }) => {
    try {
      const res = await deleteExpenseCategory(id);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return id;

    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to delete expense category"
      );
    }
  }
);